import { get } from '../../../../util/api'
import * as type from './type'
import { selectCustomerId } from '../../../customer/state/detail/selector'


export const findUnassignedCaseListRequest = () => ({
    type: type.FIND_UNASSIGNED_CASE_LIST_REQUEST,
    payload: {},
})

export const findUnassignedCaseListSuccess = (caseList) => ({
    type: type.FIND_UNASSIGNED_CASE_LIST_SUCCESS,
    payload: {
        caseList,
    },
})

export const findUnassignedCaseListError = (error) => ({
    type: type.FIND_UNASSIGNED_CASE_LIST_ERROR,
    payload: {
        error,
    },
})

export const findUnassignedCaseList = () => (dispatch, getState) => {
    const state = getState()
    const customerId = selectCustomerId(state)

    dispatch(findUnassignedCaseListRequest())

    get('/api/3shape/find-unassigned-case-list?customerId=' + customerId)
        .then(caseList => {
            dispatch(findUnassignedCaseListSuccess(caseList))
        })
        .catch(error => {
            dispatch(findUnassignedCaseListError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/threeshape/state/match/action.js